import * as React from 'react';
import { t } from '../helper/locale';
import { ConnectCard } from '../components/ConnectCard';
import { HelpTip } from '../components/HelpTip';
import { HeaderBar } from '../components/HeaderBar';
import { isFullyConfigured } from '../helper/authentication';
import { refreshStores } from '../storage/stores';
import { ButtonStatus } from '../types/onboarding';
import { redirectToSetupCompleteScreen } from '../actions/navigationActions';
import { getOnboardingHelpTip, getSetupIntentUrl } from '../constants';
import { getDocument } from '../sideEffects/browser/core';

export const SetupExtension: React.FunctionComponent = () => {
  React.useEffect(() => {
    getDocument().title = t('Let’s complete protection!');
  }, []);

  return (
    <div>
      <HeaderBar />
      <ConnectCard
        url={getSetupIntentUrl()}
        isConnected={() => refreshStores().then(isFullyConfigured)}
        onSuccessNavigation={redirectToSetupCompleteScreen}
        initialButtonStatus={
          isFullyConfigured() ? ButtonStatus.SUCCESS : ButtonStatus.ACTIVE
        }
      />
      <HelpTip url={getOnboardingHelpTip()} />
    </div>
  );
};
